import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import { CircularProgress } from '@material-ui/core';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import LogIn from '../LogIn/index';
import ForgotPassword from '../ForgotPassword/index';
import SetNewPassword from '../SetNewPassword/index';
import Matricula from '../Matricula/index';
import MatriculaExitosa from '../MatriculaExitosa/index';
import Matricular from '../Matricular/index';
import AlumnoActualizar from '../AlumnoActualizar/index';
import MatriculaVer from '../MatriculaVer/index';
import MatriculaDayCareVer from '../MatriculaDayCareVer/index';
import CargoAutomatico from '../CargoAutomatico/index';
import CargoAutomaticoExitoso from '../CargoAutomaticoExitoso/index';
import CargoAutomaticoCrear from '../CargoAutomaticoCrear/index';
import PrivateRoute from '../../shared/components/PrivateRoute';
import ReporteEstadisticas from '../ReporteEstadisticas';
import ReporteEstadisticasNuevos from '../ReporteEstadisticasNuevos';
import { loadAccesos } from '../../redux/actions/appActions';
import saga from '../LogIn/saga';
import injectSaga from '../../utils/injectSaga';
import ReporteMatriculaEstado from '../ReporteMatriculaEstado';
import ReporteCajas from '../ReporteCajas';
import ReporteBBDDCompleta from '../ReporteBBDDCompleta';
import ReporteListado from '../ReporteListado';
import NuevaMatricula from '../NuevaMatricula';
import NuevoAlumnoExitoso from '../NuevoAlumnoExitoso';
import MatriculaPendienteContrato from '../MatriculaPendienteContrato/index';
import SetFirstPassword from '../SetFirstPassword';

const AlumnoRoutes = () => (
  <Switch>
    <Route exact path="/alumno/:id/actualizar" component={AlumnoActualizar} />
  </Switch>
);


const NuevaMatriculaRoutes = () => (
  <Switch>
    <Route exact path="/nueva-matricula" component={NuevaMatricula} />
    <Route exact path="/nueva-matricula/exito" component={NuevoAlumnoExitoso} />
    <Route exact path="/nueva-matricula/pendiente-contrato" component={MatriculaPendienteContrato} />
  </Switch>
);


const MatriculaRoutes = () => (
  <Switch>
    <Route exact path="/matricula" component={Matricula} />
    <Route exact path="/matricula/exito" component={MatriculaExitosa} />
    <Route exact path="/matricula/pendiente-contrato" component={MatriculaPendienteContrato} />
    <Route exact path="/matricula/:id/matricular" component={Matricular} />
    <Route exact path="/matricula/:id/ver" component={MatriculaVer} />
    <Route exact path="/matricula/:id/ver-day-care" component={MatriculaDayCareVer} />
  </Switch>
);

const CargoAutomaticoRoutes = () => (
  <Switch>
    <Route exact path="/cargo" component={CargoAutomatico} />
    <Route exact path="/cargo/exito" component={CargoAutomaticoExitoso} />
    <Route exact path="/cargo/:id/modificar" component={CargoAutomaticoCrear} />
  </Switch>
);

const CambiarPasswordRoutes = () => (
  <Switch>
    <Route exact path="/cambiar-password" component={SetFirstPassword} />
  </Switch>
);

const mapStateToProps = state => ({
  app: state.app,
});

const withSaga = injectSaga({ key: 'wrappedRoutes', saga });

const wrappedRoutes = withSaga(connect(mapStateToProps)(class wrappedRoutes extends React.PureComponent {
  static propTypes = {
    app: PropTypes.shape({}).isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      accesosLoaded: false,
    };
  }

  componentDidMount() {
    this.cargarAccesos();
  }

  componentDidUpdate() {
    this.cargarAccesos();
  }

  cargarAccesos = () => {
    const { dispatch, app } = this.props;
    const { accesosLoaded } = this.state;
    if (app.session && !accesosLoaded) {
      dispatch(loadAccesos(app.session.id));
      this.setState({
        accesosLoaded: true,
      });
    }
  }

  hasAccess = (opcion) => {
    const { app } = this.props;
    const acceso = app.accesos.find(a => a.opcion === opcion);

    if (!acceso || !app.session || !app.session.user) return false;

    const userRoles = app.session.user.roles || [];
    const rolEncargado = app.session.user.rolEncargado;

    // Standard Check
    if (_.intersection(acceso.roles, userRoles).length > 0) return true;

    // Extended Access for Request: Enable Statistics and Listado for non-parents
    // "Estadisticas" & "Estadisticas Nuevo Ingreso" -> 'reporte'
    // "Listado por Grado" -> 'listado'
    if (['reporte', 'listado'].includes(opcion)) {
      // Check if user is likely a parent
      const isParentRole = userRoles.some(r => ['Padre', 'Madre', 'Familia', 'Encargado'].includes(r));
      const isParentEncargado = ['Padre', 'Madre'].includes(rolEncargado);

      if (!isParentRole && !isParentEncargado) {
        return true;
      }
    }
    return false;
  }

  render() {
    const { app } = this.props;

    return app.accesos.length === 0
      ? <CircularProgress className="circular-progress" />
      : (
        <div>
          <Layout />
          <div className="container__wrap">
            {
              this.hasAccess('matricula')
              && (
                <Route path="/matricula" component={MatriculaRoutes} />
              )
            }
            {
              this.hasAccess('nueva-matricula')
              && (
                <Route path="/nueva-matricula" component={NuevaMatriculaRoutes} />
              )
            }
            {
              this.hasAccess('matricula')
              && (
                <Route path="/alumno" component={AlumnoRoutes} />
              )
            }
            {
              this.hasAccess('matricula')
              && (
                <Route path="/cambiar-password" component={CambiarPasswordRoutes} />
              )
            }
            {
              this.hasAccess('cargo')
              && (
                <Route path="/cargo" component={CargoAutomaticoRoutes} />
              )
            }
            {
              this.hasAccess('reporte')
              && (
                <Route exact path="/reportes/estadisticas" component={ReporteEstadisticas} />
              )
            }
            {
              this.hasAccess('reporte')
              && (
                <Route exact path="/reportes/estadisticas-nuevos" component={ReporteEstadisticasNuevos} />
              )
            }
            {
              this.hasAccess('matriculaEstado')
              && (
                <Route exact path="/reportes/matricula-por-estado" component={ReporteMatriculaEstado} />
              )
            }
            {
              this.hasAccess('listado')
              && (
                <Route exact path="/reportes/listado-por-nivel" component={ReporteListado} />
              )
            }
            {
              this.hasAccess('cajas')
              && (
                <Route exact path="/reportes/cajas" component={ReporteCajas} />
              )
            }
            {
              this.hasAccess('bbdd-completa')
              && (
                <Route exact path="/reportes/bbdd-completa" component={ReporteBBDDCompleta} />
              )
            }
          </div>
        </div>
      );
  }
}));

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/" component={LogIn} />
        <Route exact path="/olvido-contrasenia" component={ForgotPassword} />
        <Route exact path="/cambiar-contrasenia" component={SetNewPassword} />
        <PrivateRoute path="/" component={wrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
